// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDeductibleConfigRenewalDto } from './IDeductibleConfigRenewalDto';
import {
    IDeductibleConfigRenewalDtoFromJSON,
    IDeductibleConfigRenewalDtoFromJSONTyped,
    IDeductibleConfigRenewalDtoToJSON,
    IDeductibleConfigRenewalDtoToJSONTyped,
} from './IDeductibleConfigRenewalDto';
import type { IProcessingTierRenewalDto } from './IProcessingTierRenewalDto';
import {
    IProcessingTierRenewalDtoFromJSON,
    IProcessingTierRenewalDtoFromJSONTyped,
    IProcessingTierRenewalDtoToJSON,
    IProcessingTierRenewalDtoToJSONTyped,
} from './IProcessingTierRenewalDto';

/**
 * 
 * @export
 * @interface IRenewalHealthPlanDto
 */
export interface IRenewalHealthPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalHealthPlanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalHealthPlanDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalHealthPlanDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IRenewalHealthPlanDto
     */
    parent_id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IRenewalHealthPlanDto
     */
    saving_plan_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof IRenewalHealthPlanDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof IRenewalHealthPlanDto
     */
    health_plan_types?: Set<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalHealthPlanDto
     */
    per_person_spend_limit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalHealthPlanDto
     */
    per_category_spend_limit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IRenewalHealthPlanDto
     */
    is_auto_enrollment?: boolean;
    /**
     * 
     * @type {Array<IProcessingTierRenewalDto>}
     * @memberof IRenewalHealthPlanDto
     */
    processing_tiers?: Array<IProcessingTierRenewalDto>;
    /**
     * 
     * @type {Array<IDeductibleConfigRenewalDto>}
     * @memberof IRenewalHealthPlanDto
     */
    deductible_configs?: Array<IDeductibleConfigRenewalDto>;
}

/**
 * Check if a given object implements the IRenewalHealthPlanDto interface.
 */
export function instanceOfIRenewalHealthPlanDto(value: object): value is IRenewalHealthPlanDto {
    return true;
}

export function IRenewalHealthPlanDtoFromJSON(json: any): IRenewalHealthPlanDto {
    return IRenewalHealthPlanDtoFromJSONTyped(json, false);
}

export function IRenewalHealthPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalHealthPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'saving_plan_ids': json['saving_plan_ids'] == null ? undefined : json['saving_plan_ids'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'health_plan_types': json['health_plan_types'] == null ? undefined : new Set(json['health_plan_types']),
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : json['per_person_spend_limit'],
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : json['per_category_spend_limit'],
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : json['is_auto_enrollment'],
        'processing_tiers': json['processing_tiers'] == null ? undefined : ((json['processing_tiers'] as Array<any>).map(IProcessingTierRenewalDtoFromJSON)),
        'deductible_configs': json['deductible_configs'] == null ? undefined : ((json['deductible_configs'] as Array<any>).map(IDeductibleConfigRenewalDtoFromJSON)),
    };
}

export function IRenewalHealthPlanDtoToJSON(json: any): IRenewalHealthPlanDto {
    return IRenewalHealthPlanDtoToJSONTyped(json, false);
}

export function IRenewalHealthPlanDtoToJSONTyped(value?: IRenewalHealthPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'plan_code': value['plan_code'],
        'parent_id': value['parent_id'],
        'saving_plan_ids': value['saving_plan_ids'],
        'organization_id': value['organization_id'],
        'health_plan_types': value['health_plan_types'] == null ? undefined : Array.from(value['health_plan_types'] as Set<any>),
        'per_person_spend_limit': value['per_person_spend_limit'],
        'per_category_spend_limit': value['per_category_spend_limit'],
        'is_auto_enrollment': value['is_auto_enrollment'],
        'processing_tiers': value['processing_tiers'] == null ? undefined : ((value['processing_tiers'] as Array<any>).map(IProcessingTierRenewalDtoToJSON)),
        'deductible_configs': value['deductible_configs'] == null ? undefined : ((value['deductible_configs'] as Array<any>).map(IDeductibleConfigRenewalDtoToJSON)),
    };
}

